import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import NewsInnerPage from './pages/NewsInnerPage';
import CompanyPage from "./pages/CompanyPage";
import ContactPage from "./pages/ContactPage";
import InvestorsPage from "./pages/InvestorsPage";
import NewsPage from "./pages/NewsPage";
import MediaCentrePage from "./pages/MediaCentrePage";
import MediaGalleryPage from "./pages/MediaGalleryPage";
import ProjectInnerPage from "./pages/ProjectInnerPage";
import ProjectInnerPage2 from "./pages/ProjectInnerPage2";
import LegalContent from "./pages/LegalContent";
import ComingSoon from "./pages/ComingSoon";
import PrPostPage from './pages/PrPostPage';
import RedirectOrNotFound from "./pages/RedirectOrNotFound";

function App() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/news/:slug" element={<NewsInnerPage />} />
                <Route path="/project/mine-centre" element={<ProjectInnerPage />} />
                <Route path="/project/quartz-mountain" element={<ProjectInnerPage2 />} />
                <Route path="/company" element={<CompanyPage />} />
                <Route path="/news" element={<NewsPage />} />
                <Route path="/media-centre" element={<MediaCentrePage />} />
                <Route path="/media-centre/:slug" element={<MediaGalleryPage />} />
                <Route path="/investors" element={<InvestorsPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/legal-notice" element={<LegalContent />} />
                <Route path="/coming-soon" element={<ComingSoon />} />
                <Route path="/admin/post" element={<PrPostPage />} />
                <Route path="*" element={<RedirectOrNotFound />} />
            </Routes>
        </Router>
    );
}

export default App;
